import { Controller } from "@hotwired/stimulus"
import { showBlock, check_auth_status } from "lib/helpers"

// chat--alert-settings on offline messaging push notification form (`chat/alerts/index`).
export default class extends Controller {
  static targets = ["alertText", "alertForm", "activeCheckbox"]

  connect() {
    if (!this.hasAlertFormTarget) return

    if ($("#chat_alert_type_template_3").is(":checked") && this.hasAlertTextTarget) {
      this.alertTextTarget.disabled = false
    }

    this.#bindTemplateRadios()
    this.#bindSoundRadios()
    this.#bindAlertText()
    this.#bindLabelClicks()
    this.#bindActiveToggle()
    this.#initAjaxForm()
    this.#initPlanPopovers()
  }

  disconnect() {
    $(".message-templates-radio-group input[type=radio]").off(".chatAlertSettings")
    $(".chat-alert-sound-radio-group input[type=radio]").off(".chatAlertSettings")
    if (this.hasAlertTextTarget) $(this.alertTextTarget).off(".chatAlertSettings")
    this.element.querySelectorAll("label").forEach((label) => $(label).off(".chatAlertSettings"))
    if (this.hasActiveCheckboxTarget) $(this.activeCheckboxTarget).off(".chatAlertSettings")
    $("[data-feature-info]").off(".chatAlertSettings").popover("destroy")

    if (this.hasAlertFormTarget) $(this.alertFormTarget).ajaxFormUnbind()
  }

  #bindTemplateRadios() {
    $(".message-templates-radio-group input[type=radio]").on("change.chatAlertSettings", function () {
      let tmpl
      switch ($(this).val()) {
        case "1":
          tmpl = window.page_args.only_num
          $("#chat_alert_text").attr("disabled", true)
          break
        case "2":
          tmpl = window.page_args.num_name
          $("#chat_alert_text").attr("disabled", true)
          break
        case "3":
          tmpl = window.page_args.custom
          $("#chat_alert_text").attr("disabled", false)
          break
      }
      $("#chat_alert_text").val(tmpl)
    })
  }

  #bindSoundRadios() {
    $(".chat-alert-sound-radio-group input[type=radio]").on("change.chatAlertSettings", function () {
      const sound = $(this).val() !== "3"
      $("#chat_alert_custom_sound").attr("disabled", sound)
    })
  }

  #bindAlertText() {
    if (!this.hasAlertTextTarget) return
    $(this.alertTextTarget).on("change.chatAlertSettings keyup.chatAlertSettings select.chatAlertSettings", function () {
      window.page_args.custom = $(this).val()
      $("#chat_alert_type_template_3").attr("checked", true)
    })
  }

  #bindLabelClicks() {
    this.element.querySelectorAll("label").forEach((label) => {
      $(label).on("click.chatAlertSettings", function () {
        $(this).siblings("input[type=radio]").click()
      })
    })
  }

  #bindActiveToggle() {
    if (!this.hasActiveCheckboxTarget) return
    $(this.activeCheckboxTarget).on("change.chatAlertSettings", function () {
      if ($(this).is(":checked")) {
        $(".alert_settings_box").removeClass("none-info-box")
        $(".alert_settings_box input").each(function () {
          $(this).attr("disabled", false)
        })
      } else {
        $(".alert_settings_box input").each(function () {
          $(this).attr("disabled", true)
        })
        $(".alert_settings_box").addClass("none-info-box")
      }
    })
  }

  #initAjaxForm() {
    $(this.alertFormTarget).ajaxForm({
      dataType: "json",
      success: (response) => {
        if (response.success) {
          showBlock("#update-result", response.message)
        } else {
          showBlock("#update-errors", response.message)
        }
        this.#scrollToTop()
      },
      error: (response) => {
        showBlock("#update-errors", "An error occurred during request")
        check_auth_status(response.status)
        this.#scrollToTop()
      },
    })
  }

  #scrollToTop() {
    $("body, html").animate({ scrollTop: 0 }, 800)
  }

  #initPlanPopovers() {
    $("[data-feature-info]")
      .popover()
      .on("show.bs.popover.chatAlertSettings", function () {
        $(this).data("bs.popover").tip().css("max-width", "600px")
      })
  }
}
